import React from "react";
import "../pagina-pagar/Style.css";
import Pagar from "../../components/acesso-rapido/pagar/Pagar";

export default function () {
  return <Pagar />;
}
